exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-card[data-v-1003c31f] {\n    padding: 20px 25px 25px 25px;\n}\n.server-info[data-v-1003c31f] {\n    margin-top: 15px;\n    text-align: center;\n}\n.agency-title[data-v-1003c31f] {\n    text-align: center;\n}\n@media screen and (min-width: 600px) {\n.agency-title[data-v-1003c31f] {\n        text-align: left !important;\n}\n}\n", ""]);

